import { useRef } from 'react';
import { ScrollButton } from './ScrollButton/index.js';
import { TabNavContainer, ScrollableTabNav } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useTabManager } from '../hooks/useTabManager/useTabManager.js';

function TabNav(props) {
  var children = props.children,
    scrollLeftButtonLabel = props.scrollLeftButtonLabel,
    scrollRightButtonLabel = props.scrollRightButtonLabel,
    className = props.className;
  var _useTabManager = useTabManager(),
    tabGroupId = _useTabManager.tabGroupId;
  var ref = useRef(null);
  var scroll = function scroll(distance) {
    var _a;
    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollBy({
      left: distance,
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/jsxs(TabNavContainer, {
    role: "tablist",
    id: tabGroupId,
    className: className,
    children: [scrollLeftButtonLabel && /*#__PURE__*/jsx(ScrollButton, {
      direction: "left",
      onClick: function onClick() {
        return scroll(-100);
      },
      label: scrollLeftButtonLabel
    }), /*#__PURE__*/jsx(ScrollableTabNav, {
      ref: ref,
      children: children
    }), scrollRightButtonLabel && /*#__PURE__*/jsx(ScrollButton, {
      direction: "right",
      onClick: function onClick() {
        return scroll(100);
      },
      label: scrollRightButtonLabel
    })]
  });
}

export { TabNav };
